<template>
<div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <div class="col-xs-12">


        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-muted">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBanner===0">
                          <button type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBanner">
                          <button  type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBanner()"><i class="fa fa-dashboard fa-1x push-5-r"></i>  {{subService.reference_name}}</h2>
            </div>

            <div v-if="flagDisplayBanner" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Main Service Detail Information  -->
                    <div v-if="flagDisplayDetail===0" class="block">

                        <button  type="button" @click="toggleConfigView()" class="btn btn-default align-right" name="buttonAddPlanItem">
                          <i class="fa fa-gear fa-1x push-5-r "></i>{{ labelButtonConfig[actualLanguage] }}</button>

                        <h2 class="block-title push">{{labelTitleGraph[actualLanguage]}}</h2>

                          <div class="col-xs-12 push">
                            <div class="col-xs-12 col-md-6 align-center">
                              <h5>{{labelButton[actualLanguage]}}</h5>
                            </div>
                            <div class="col-xs-12 col-md-6">
                              <label class="css-input switch switch-success">
                              <input type="checkbox" checked v-model="flagReadByInvoiceData">
                              <span></span>
                              <h5 v-if="flagReadByInvoiceData">{{lableActivated[actualLanguage]}}</h5>
                              <h5 v-else>{{lableNotActivated[actualLanguage]}}</h5>
                            </label>
                            </div>
                          </div>

                          <div class="col-xs-12 push">
                            <div class="col-xs-12 col-md-4">
                              <div class="input-daterange form-group row">
                                  <div class="input-date-time-picker" >
                                    <date-picker
                                        class="el-input__inner form-control"
                                        v-model="visualisationDateStart"
                                        type="date"
                                        placeholder=""
                                        clear-icon=""
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                    />
                                  </div>
                              </div>
                            </div>

                            <div class="col-xs-12 col-md-4">
                              <div class="input-daterange form-group row">
                                  <div class="input-date-time-picker" >
                                    <date-picker
                                        class="el-input__inner form-control"
                                        v-model="visualisationDateEnd"
                                        type="date"
                                        placeholder=""
                                        clear-icon=""
                                        format="yyyy-MM-dd"
                                        value-format="timestamp"
                                    />
                                  </div>
                              </div>
                            </div>

                            <div class="col-xs-12 col-md-4">
                                <button  type="button" @click="readSubServiceGraphData()" class="btn btn-default align-right" name="buttonAddPlanItem">
                                  {{ labelButtonReadGraph[actualLanguage] }}</button>
                            </div>
                          </div>


                        <div class="col-xs-12 push">

                          <div v-if="flagGraphDataIsUpdating" class="col-xs-12 col-md-12">
                            <spinner size="large"></spinner>
                          </div>

                          <div v-if="flagDisplayGraph" class="col-xs-12 col-md-12">
                              <graph-apex-bars :GraphData="barChartDataSub1" ></graph-apex-bars>
                          </div>


                        </div>
                    </div>





                    <!-- Main Service Detail Information  -->
                    <div v-else class="block">
                         <button  type="button" @click="toggleConfigView()" class="btn btn-default align-right" name="buttonAddPlanItem">
                          <i class="fa fa-close fa-1x push-5-r "></i>{{ labelButtonConfigClose[actualLanguage] }}</button>                       

                        <h1 class="block-title push">Configuration service ID: {{ subService.sub_service_id}}</h1>

                        <div class="col-xs-12 col-md-12 push-50">
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelRefenrenceName[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6">
                                <input v-model="subService.reference_name" class="form-control align-center" type="test"  placeholder="">
                          </div>
                        </div>

                        <h1 class="block-title push">{{labelSectionTitleLinkedChannel[actualLanguage]}}</h1>
                        <div class="col-xs-12 col-md-12">
                          <label class="col-xs-12" for="example-select">{{ selectLabelLinkedChannel[actualLanguage] }}</label>
                          <div class="col-xs-12 col-md-12 push">
                                <div class="form-group">
                                  <div class="col-sm-9">
                                      <select class="form-control" v-model=channelToAddIndex size="1">
                                          <option v-for="(channel,channelIndex) in actualBundle.channels" :value="channelIndex">{{channel.ReferenceName}}</option>
                                      </select>
                                  </div>
                                  <div class="col-xs-12 col-md-3">
                                    <button  type="button" @click="addChannelToLinkedChannel()" class="btn btn-xs align-left" name="buttonAddPlanItem">
                                    <i class="fa fa-plus fa-1x push-5-r "></i>{{ channelAddButton[actualLanguage] }}</button>
                                  </div>
                              </div>
                          </div>
                        </div>


                        <div v-if="subService.linked_channel.length > 0" class="col-xs-12 col-md-12">
                          <div class="table-responsive push">
                              <table class="table table-striped table-vcenter">
                                  <thead>
                                      <tr>
                                          <th style="width: 65%;">{{channelTableColumn01[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 10%;">{{channelTableColumn02[actualLanguage]}}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for= "(channel,index) in subService.linked_channel">
                                          <td>{{channel.referenceName}}</td>
                                          <td class="text-center">
                                              <div class="btn-group">
                                                  <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                  @click="deleteLinkedChannel(index)" title="Supprimer/Delete"><i class="fa fa-trash"></i></button>
                                              </div>
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                        </div>



                        <div class="col-xs-12 col-md-12 push">
                        <button  type="button" @click="saveSubServiceModifications()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                        <spinner size="small" v-if="serviceIsSaving"></spinner>
                        <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</span></button> 
                        </div>





                        <h1 class="block-title push">Options</h1>
                        <div class="col-xs-12 col-md-12">

                            <div v-for="(category,index) in subService.options" class="col-xs-12 col-md-12 push">
                              <h5  class=""><u>{{category.categoryTitle[actualLanguage]}}</u></h5>
                              <p class="push-30">{{category.categoryDescription[actualLanguage]}}</p>

                              <div v-for="(Option,index2) in category.options" class="col-xs-12 col-md-12 push">

                                <div v-if="Option.valueType=='bool'" class="col-xs-12 col-md-12">

                                  <div class="col-xs-12 col-sm-9">
                                      <h5>{{Option.optionLabel[actualLanguage]}}</h5>
                                  </div>
                                  <div class="col-xs-12 col-sm-3">
                                      <label class="css-input switch switch-success">
                                      <input type="checkbox" checked v-model="Option.value">
                                      <span></span><p v-if="Option.value">{{labelActivated[actualLanguage]}}</p>
                                      </label>
                                  </div>

                                </div>



                                <div v-if="Option.valueType=='stringNumber'" class="col-xs-12 col-md-12 push">
                                  <div class="col-xs-12 col-sm-9">
                                      <h6>{{Option.optionLabel[actualLanguage]}}</h6>
                                  </div>
                                  <div class="col-xs-12 col-sm-3">
                                        <input v-model="Option.value" class="form-control align-center" type="test"  placeholder="">
                                  </div>
                                </div>


                                <div v-if="Option.valueType=='listString'" class="col-xs-12 col-md-12">
                                  {{Option}}
                                </div>

                              </div>

                            </div>

                        </div>

                        <button  type="button" @click="saveSubServiceModifications()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                        <spinner size="small" v-if="serviceIsSaving"></spinner>
                        <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</span></button> 



                    </div>

                    <!-- END Static Labels -->
                    </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'
import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import GraphApexBars from './GraphApexBars'
import moment from 'moment';

export default {
  name: 'GroupIndex',
  props: ['subService'],
 
  data() {
    return {
      flagDisplayBanner : 0,
      flagDisplayDetail : 0,
      profileIsSaving : false,
      serviceIsSaving : false,
      actualLanguage : "FR",
      labelTitleSection: {FR: 'Titre bannière', EN: 'Banner Title'},
      labelTitleBanner: {FR: 'Titre bannière', EN: 'Banner Title'},

      labelButtonConfig: {FR: 'Configuration', EN: 'Configuration'},
      labelButtonConfigClose: {FR: 'Fermer configuration', EN: 'Close configuration'},
      labelButtonSaveModifications: {FR: 'Enregistrer modifications', EN: 'Save modifications'},

      labelRefenrenceName: {FR: "Nom de référence du service", EN: 'Service reference name'},
      selectLabelLinkedChannel : {FR: "Pour liées un ou des appareils mesurés a ce service, sélectionnez l'appareil dans la liste et utiliser le bouton 'Ajouter l'appareil'",
                                   EN: "To link one or more devices measured to this service, select the device in the list and use the 'Add device' button"},
      channelToAddIndex : '',
      channelAddButton: {FR: "Ajouter l'appareil", EN: "Add monitored device"},
      channelTableColumn01: {FR: "Liste d'appareils liée au service", EN: 'Linked monitored device'},
      channelTableColumn02: {FR: "Retirer", EN: 'Delete'},


      messageSaveModifRequired: {FR: "Vous devez utiliser le bouton 'Enregistrer modifications' pour que les modifications soient enregistrés dans le système.",
                    EN: "You must use the 'Save Modifications' to save modification into the system."},
      messageSaveModifFlag : true,


      tableOptionsColumnTitle01: {FR: "Description de l'option", EN: "Option description"},
      tableOptionsColumnTitle02: {FR: "Détail de l'option", EN: "Option detail"},
      labelActivated: {FR: "Activé", EN: 'Activated'},

      labelSectionTitleLinkedChannel: {FR: "Appareil(s) mesuré(s) lié(s) au sous-service",
                                         EN: 'Add sub service'},
      labelButtonAddSubService: {FR: "Ajouter un sous service", EN: 'Add sub service'},

      labelTitleGraph: {FR: 'Mesures du sous service', EN: 'Sub service measurement'},
      flagReadByInvoiceData : false,
      labelButton: {FR: "Données selon les saisies de factures",
                    EN: 'Read data according to billing data'},
      lableActivated :  {FR: "Activé", EN: 'Enabled'},
      lableNotActivated :  {FR: "Désactivé", EN: 'Disabled'},



      visualisationDateStart : '',
      visualisationDateEnd : '',

      flagDisplayGraph : false,
      flagGraphDataIsUpdating : false,
      labelButtonReadGraph: {FR: "Actualiser le graphique", EN: 'Refresh graph'},
      GraphData : [],
      barChartDataSub1 : {ChartTitle:{FR: 'Distribution des coûts',
                                     EN: 'Distribution of costs'},
                      XData : [],
                      YData  : [],
                      Options:{Stacked:true,StackType:"normal"}},

    }
  },
  components: {
    Spinner,
    DatePicker,
    TimePicker,
    TimeSelect,
    GraphApexBars,
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.flagDisplayBanner = ~this.flagDisplayBanner
      console.log(this.flagDisplayBanner)
      if (this.flagDisplayBanner==-1){this.readSubServiceGraphData()}
    },

  toggleConfigView(){
    this.flagDisplayDetail = ~this.flagDisplayDetail
    
  },

  addChannelToLinkedChannel(){
    this.subService.linked_channel.push({channelId:this.actualBundle.channels[this.channelToAddIndex].ChannelData.channelId,
                                            referenceName:this.actualBundle.channels[this.channelToAddIndex].ReferenceName})
    this.messageSaveModif()
  },

  deleteLinkedChannel(index){
    this.subService.linked_channel.pop(index)
    this.messageSaveModif()
  },

  messageSaveModif(){
    if (this.messageSaveModifFlag){
      window.alert(this.messageSaveModifRequired[this.actualLanguage])
      this.messageSaveModifFlag = false
    }
    
  },

  saveSubServiceModifications(){
        var requestData = {'postAction':'SaveSubService',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'subServiceData':this.subService}
        this.serviceIsSaving=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.serviceIsSaving=false
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },


    readSubServiceGraphData(){
        this.flagDisplayGraph = false
        this.flagGraphDataIsUpdating = true
        var GraphReadPostAction = 'GetSubServiceGraphData'

        if (this.flagReadByInvoiceData){
          GraphReadPostAction = 'GetSubServiceGraphDataFromInvoices'
        }

        var requestData = {'postAction':GraphReadPostAction,
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'mainServiceId':this.subService.main_service_id,
                          'subServiceId':this.subService.sub_service_id,
                          'dateStart':this.visualisationDateStart,
                          'dateEnd':this.visualisationDateEnd}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              console.log(response.data)
              this.flagGraphDataIsUpdating = false
            if(response.data.Code=='OK'){
                this.GraphData = response.data.GraphData

                this.barChartDataSub1.XData = response.data.BarData.subXData
                this.barChartDataSub1.YData = response.data.BarData.subYData


                this.flagDisplayGraph = true
                //console.log(this.MainServiceList)
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })

    },






    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },



    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    var thisDayUnix = (Math.floor(moment().unix()/(24*3600)))*(24*3600)
    this.visualisationDateStart =((thisDayUnix-7*24*3600) * 1000)
    this.visualisationDateEnd = (thisDayUnix * 1000)
  }
}
</script>





// WEBPACK FOOTER //
// SubServiceDisplay.vue?4e6bfd45